<template>
    <FilterCompoennt :data="data" />
    <BoardListComponent :data="data" />
    <PaginationComponent :data="data" />
</template>

<script>
import BoardListComponent from '@/components/BoardListComponent.vue';
import FilterCompoennt from '@/components/FilterCompoennt.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';

export default {
    components: {
        FilterCompoennt,
        BoardListComponent,
        PaginationComponent,
    },
    props: {
        data: {},
    },
};
</script>
